export default __webpack_public_path__ + "static/media/oxygen-icon.2915f0af.svg";